import { Children } from 'react';
import { Tab } from './Tab';

/**
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode[]} props.children - The tab items to render.
 * @param {(index: number) => void} props.setActiveTab - Callback fired when a tab is clicked.
 * @param {number} props.activeTab - The index of the active tab.
 * @param {Object} [props.style={}] - Custom styles applied to the tab list container.
 * @param {'border' | 'background'} [props.variant='border'] - The visual style used to highlight the active tab.
 */
export const TabList = ({ children, setActiveTab, activeTab, style = {}, variant = 'border' }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 20,
      ...style,
    }}
  >
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginBottom: variant === 'background' ? 0 : 20,
        gap: variant === 'background' ? 10 : 40,
        ...style,
      }}
    >
      {Children.map(children, (child, index) => {
        if (child.type.displayName === 'Tab') {
          return (
            <Tab
              variant={variant}
              isActive={activeTab === index}
              setActiveTab={() => setActiveTab(index)}
              {...child.props}
            />
          );
        }
        return null;
      })}
    </div>
  </div>
);

TabList.displayName = 'TabList';
